export default __webpack_public_path__ + "static/media/banner5.d664ffe8.jpg";